import { Usage } from "../generated/usage/usage";
import { Control } from "../generated/control/control";
import { DeviceDirection } from "../../types/DeviceDirection";

const DIRECTION_DISPLAY: Partial<Record<number, string>> = {
  [Usage.Up]: "Up",
  [Usage.Down]: "Down",
  [Usage.Forward]: "Forward",
  [Usage.Backward]: "Backward",
  [Usage.RunUp]: "Run Up",
  [Usage.RunDown]: "Run Down",
  [Usage.Moving]: "Moving",
};

export function directionDisplayName(d: DeviceDirection): string {
  if (d === null) return "Idle";
  return DIRECTION_DISPLAY[d] ?? "Unknown";
}

const DOOR_ZONE_DISPLAY: Partial<Record<Usage, string>> = {
  [Usage.AboveDoorZone]: "Above Door Zone",
  [Usage.InDoorZone]: "In Door Zone",
  [Usage.BelowDoorZone]: "Below Door Zone",
};

export function doorZoneDisplayName(code: Usage | null): string {
  if (code === null) return "";
  return DOOR_ZONE_DISPLAY[code] ?? `Unknown (${code})`;
}

const ESCALATOR_CONTROL_DISPLAY: Partial<Record<Control, string>> = {
  [Control.RunUp]: "Run Up",
  [Control.RunDown]: "Run Down",
  [Control.Stop]: "Stop",
};

export function escalatorControlDisplayName(code: Control | null): string {
  if (code === null) return "";
  return ESCALATOR_CONTROL_DISPLAY[code] ?? `Unknown (${code})`;
}

export function directionStringToEnum(s: string): DeviceDirection {
  switch (s) {
    case "Up":
      return Usage.Up;
    case "Down":
      return Usage.Down;
    case "Forward":
      return Usage.Forward;
    case "Backward":
      return Usage.Backward;
    case "Idle":
      return null;
    default:
      return null;
  }
}

export function doorZoneStringToEnum(s: string): Usage | null {
  switch (s) {
    case "AboveDoorZone":
      return Usage.AboveDoorZone;
    case "InDoorZone":
      return Usage.InDoorZone;
    case "BelowDoorZone":
      return Usage.BelowDoorZone;
    default:
      return null;
  }
}

export function escControlStringToEnum(s: string): Control | null {
  switch (s) {
    case "RunUp":
      return Control.RunUp;
    case "RunDown":
      return Control.RunDown;
    case "Stop":
      return Control.Stop;
    default:
      return null;
  }
}
